export const nbsp = '\u00A0';
export const times = '\u00D7';
